<template>
  <div>
    <div class="text-center">
      <h2 class="text-2xl tracking-wide leading-10 font-extrabold font-bebas text-peach mt-4 sm:text-5xl sm:leading-none md:text-4xl" >
        Meet the Speakers
      </h2>
      <p class="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">

      </p>
    </div>
    <div class="md:grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
      <div
        v-for="(speaker, idx) in speakers"
        :key="idx"
        class="shadow hover:shadow-2xl
          bg-light-paper
                transform hover:scale-105 cursor-pointer"
      >
        <router-link :to="'/speaker/' + speaker._id">
          <a>
            <img
              :src="imageForSpeaker(speaker)"
              class="h-64 w-full object-cover shadow"
              alt=""
            />
            <div class="p-4 font-bebas text-darkpurple tracking-wide text-2xl text-center">
              {{ speaker.name }}
            </div>
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "Speakers",
  data() {
    return {
      speakers: []
    };
  },
  mounted() {
    this.fetchSpeakers();
  },
  methods: {
    fetchSpeakers() {
      const queryString = "*[_type == 'speaker'] {...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          this.speakers = res;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    imageForSpeaker(speaker) {
      return sanityImageBuilder
        .image(speaker.portrait)
        .crop("focalpoint")

        .url();
    }
  }
};
</script>

<style scoped></style>
